import { V2Alert } from '@abyss/web/ui/Alert';
import { find } from 'lodash';

import { ConstantsLagoon } from '../../../common/ConstantsLagoon';
import { useLagoon } from '../../../hooks/useLagoon/useLagoon';

const firstTimeUserBannerStyle = {
  'abyss-alert-root': {
    borderBottomColor: '#C3D8F2',
    paddingRight: '32px',
    paddingLeft: '16px',
  },
  'abyss-alert-icon': {
    alignSelf: 'center',
  },
  'abyss-alert-separator': {
    height: '32px',
    alignSelf: 'center',
  },
};

export const FirstTimeUserBanner = ({
  content,
  onClose,
  onLearnMoreClick,
  showLearnMoreButton = true,
}: {
  content: string;
  onClose: () => void;
  onLearnMoreClick?: () => void;
  showLearnMoreButton?: boolean;
}) => {
  const lagoonUIMessage = useLagoon('ui-messaging')();

  const learnMoreButtonText = find(lagoonUIMessage, {
    key: ConstantsLagoon.GUEST_PLAN_SELECTION.LEARN_MORE_BUTTON_TEXT,
  })?.message;

  return (
    <V2Alert
      css={firstTimeUserBannerStyle}
      cta={
        showLearnMoreButton
          ? {
              type: 'button',
              props: {
                children: learnMoreButtonText,
                onClick: onLearnMoreClick,
              },
            }
          : undefined
      }
      data-testid="first-time-user-banner"
      onClose={onClose}
      status="info"
    >
      {content}
    </V2Alert>
  );
};
